"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Cookie = require("js-cookie");
function getReceivingChannel() {
    // const platform = navigator.platform.toLowerCase();
    var userAgent = navigator.userAgent.toLowerCase();
    var isAliapy = /alipayclient/.test(userAgent);
    var isZLB = /dtdreamweb|zlbnewweb/.test(userAgent);
    var href = location.href.toString();
    if (window.receivingChannel) {
        return window.receivingChannel;
    }
    else if (href.indexOf("offline-intg") >= 0) {
        return "offline-intg";
    }
    else if (href.indexOf("offline-pad") >= 0) {
        return "offline-pad";
    }
    else if (isAliapy) {
        return "h5-alipay";
    }
    else if (isZLB) {
        return "h5-zlb";
    }
    else {
        return "default";
    }
}
exports.getReceivingChannel = getReceivingChannel;
function getOperationSystem() {
    var platform = navigator.platform.toLowerCase();
    var userAgent = navigator.userAgent.toLowerCase();
    if (platform.indexOf("mac") >= 0) {
        return "macos";
    }
    else if (platform.indexOf("win") >= 0) {
        return "windows";
    }
    else if (/linux/i.test(userAgent)) {
        return "linux";
    }
    else {
        return "other";
    }
}
exports.getOperationSystem = getOperationSystem;
function getDeviceType() {
    if (/(iphone|ios)/i.test(navigator.userAgent) || /(android)/i.test(navigator.userAgent)) {
        return "mobile";
    }
    else if (/(ipad)/i.test(navigator.userAgent)) {
        return "pad";
    }
    else {
        return "pc";
    }
}
exports.getDeviceType = getDeviceType;
function getUserType() {
    return Cookie.get("clientUserType") || "person";
}
exports.getUserType = getUserType;
function deviceFactor() {
    return {
        "gov-rc": getReceivingChannel(),
        "gov-os": getOperationSystem(),
        "gov-dt": getDeviceType() === "pc" ? "pc" : "h5",
        "guc-accountType": getUserType(),
        "guc-platform": "pc",
        "guc-endpoint": "C",
        "x-gov-tenant": "zj",
        "userType": getUserType(),
    };
}
exports.deviceFactor = deviceFactor;
